import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatScaleHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 16H1.75m16.5 0-2-2.25m2 2.25-2 2.25M1.75 16l2-2.25m-2 2.25 2 2.25M10 1.75H6.75a1 1 0 0 0-1 1v2m4.25-3h3.25a1 1 0 0 1 1 1v2m-4.25-3v10.5m0 0H7.75m2.25 0h2.25"
	})]
});
const ForwardRef = forwardRef(SvgFormatScaleHorizontal);
export { ForwardRef as ReactComponent };
